import {mutations} from './mutations';
import {actions} from './actions';
import {getters} from './getters';

const state = {
    panelists: [],
    panelistsLoading: false,
    searchActive: false,
    search: {
        term: '',
        size: 100,
        ids: [],
    },
    meta: {
        available: 0,
        executionTime: 0
    },

    headers: [],
    selectedVariables: [],
    selectedVariableIds: [],
    itemsPerPage: 100,

    selectedRows: [],

    actions: [
        {
            name: 'Change subscription status',
            type: 'status',
            icon: 'mdi-account-alert',
            permission: 'update panelists',
            options: {
                values: [
                    {name: 'Subscribed', value: 1},
                    {name: 'Unsubscribed', value: 2},
                    {name: 'Blacklisted', value: 3}
                ],
                label: 'Select new subscription status',
                multiple: false,
            },
            selected: null,
        },
        {
            name: 'Delete panelists',
            type: 'delete',
            permission: 'delete panelists',
            icon: 'mdi-account-remove',
        },
        {
            name: 'Export panelists to CSV',
            type: 'export',
            icon: 'mdi-account-details',
            permission: 'export panelists',
            options: {
                values: [
                    {name: 'Decode multiple choice values', value: true},
                    {name: 'Export data as stored', value: false},
                ],
                label: 'Select coding',
                multiple: false,
            },
            selected: null,
        },
    ],

    // Filters
    filters: [
        {
            type: 'queryFilter',
            name: 'Query filter',
            description: 'Create a new ad hoc query filter',
            icon: 'mdi-filter',
            clickable: true,
            model: false,
            custom: {
                name: null,
                jsonQuery: null,
                jsonFilter: null
            }
        },
        {
            type: 'segment',
            name: 'Existing query filter',
            description: 'Select from saved query filters',
            icon: 'mdi-filter',
            clickable: true,
            model: false,
            custom: {
                name: null,
                jsonQuery: null,
                jsonFilter: null
            }
        }
    ],

    // Currently edited profile
    profile: {},
    profileLoading: false,

    activityTableSettings: {
        itemsPerPage: -1,
        sortBy: ['created_at'],
        sortDesc: [true],
    },

    rewardsTableSettings: {
        itemsPerPage: -1,
        sortBy: ['created_at'],
        sortDesc: [true],
    },

    redemptionsTableSettings: {
        itemsPerPage: -1,
        sortBy: ['created_at'],
        sortDesc: [true],
    },


    variablesEditableOnly: true,
    variablesFilterModel: null,
    variablesSearchTerm: null,

    timeLineFilters: [
        "projectProfile",
        "projectQuota",
        "projectCompleted",
        "email",
        "start",
        "termination",
        "completed",
        "redemption",
        "reward",
        "subscription"
    ],
}

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations
}

